import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-account",
  "use": "icon-icon-account-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-account\"><defs><style type=\"text/css\"></style></defs><path d=\"M287.695238 433.980952h97.52381v97.52381h-97.52381zM463.238095 336.457143h97.52381v195.047619h-97.52381zM638.780952 238.933333h97.52381v292.571429h-97.52381z\" p-id=\"14566\" /><path d=\"M906.971429 614.4V58.514286H117.028571v551.009524H34.133333v351.085714h950.857143v-351.085714h-78.019047zM214.552381 156.038095h594.895238v453.485715h-258.438095v102.4H468.114286v-102.4H214.552381V156.038095z m677.790476 711.92381H131.657143v-156.038095h238.933333v19.504761c0 48.761905 39.009524 82.895238 82.895238 82.895239h112.152381c43.885714 0 82.895238-39.009524 82.895238-82.895239v-19.504761h238.933334v156.038095z\" p-id=\"14567\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-account.svg
// module id = HXG9
// module chunks = 46